export const environment = {
  production: true,
  readyConfig: {
    serverUrl: 'https://api.readypay.co',
    favicon: 'favicon.png',
    leaseExpiryDuration: 60 * 1000,
    leaseRenewalDuration: 30 * 1000
  },
  firebaseConfig: {
    apiKey: 'AIzaSyAauwL8v2W1WYh3S5FSKJUoI8_-OzOiJdg',
    authDomain: 'readytopay.firebaseapp.com',
    databaseURL: 'https://readytopay.firebaseio.com',
    storageBucket: 'firebase-readytopay.appspot.com',
    messagingSenderId: '2134214'
  },
  readyDomains: [
    'READYPAY.CO',
    'READY.MENU',
    'PAY.THEBEACHHOUSERESTAURANT.CA',
    'MENU.THEBEACHHOUSERESTAURANT.CA',
    'MENU.SALTYSBEACHHOUSE.COM',
    'FP.READYPAY.CO',
    'FP.READY.MENU',
    'LOT185.VANCONVENTIONS.COM',
    'READY.BCPLACE.COM',
    'ORDER.VANCONVENTIONS.COM',
    'PAY.EARLS.CA',
    'PAY.BIRDIESRESTAURANT.COM',
    'PAY.THEBEACHHOUSERESTAURANT.CA',
    'PAY.EARLSRESTAURANTS.COM'
  ],
  AmsConfig: {
    serviceUrl: 'https://ams.iqmetrix.net'
  },
  AdyenConfig: {
    serviceDomain: 'adyen.com',
    clientKey: 'live_KMV2JVKI4VEVTEIGVANCPGGA2MWZQWCL',
    environment: 'LIVE',
    googlePayEnvironment: 'PRODUCTION'
  },
  IQPaymentsConfig: {
    merchantId: 'merchant.com.paymentservicesgateway',
    hostedFormsUrl: 'https://hostedpaymentform.iqmetrix.net'
  },
  FreedomPayConfig: {
    serviceDomain: 'hpc.freedompay.com'
  },
  StripeConfig: {
    publishableKey: 'pk_live_3srnfIix3gXh7O8qvEIujHwJ'
  },
  RealexConfig: {
    hppUrl: 'https://pay.realexpayments.com/pay'
  },
  SquareConfig: {
    applicationId: 'sq0idp-NKLtHSl52vqZlbDLdQJlDg'
  },
  DynamicPaymentProcessorApiScripts: {
    freedompay: ['https://hpc.freedompay.com/api/v1.5/cdn/applepay_min.js'],
    square: ['https://web.squarecdn.com/v1/square.js']
  },
  RecaptchaConfig: {
    siteKey: '6LdymjgcAAAAABMFdIxUfQbJWtW152xtoq9_lMjr'
  },
  env: 'prod',
  GoogleAnalyticsId: 'UA-68293320-2',
  GoogleAnalytics4MeasurementId: 'G-C1RQD8LRWN',
  ExperimentRunning: false,
  EventPollingIntervalMilliseconds: 60000
};
